import React from "react"

const Ribbon = () => {
  return (
    <div className="bg-[#505a60] text-white py-1 px-3 rounded-tl-lg rounded-tr-lg flex items-center space-x-2">
      <span>POWERED BY</span>
      <span>Calendly</span>
    </div>
  )
}

export default Ribbon
